/*
 * Copyright(c) 2024 Magrabi.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Magrabi ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Magrabi.
 *
 * @author Indrajit
 */

export const endPageTransition = () => {
  if (typeof window !== "undefined") {
    document.body.classList.remove("page-transition");
    if (window.hideLoading) {
      clearTimeout(window.hideLoading);
    }
  }
};

export const startPageTransition = (autoClose = true, duration = 9000) => {
  if (typeof window !== "undefined") {
    document.body.classList.add("page-transition");
    if (window.hideLoading) {
      clearTimeout(window.hideLoading);
    }
    if (autoClose) {
      window.hideLoading = setTimeout(() => {
        endPageTransition();
      }, duration);
    }
  }
};
